import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice/AuthSlice";

import { apiSlice } from "./features/api/apiSlice";
import { dogReducer } from "./features/dogSlice/dogReducerSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import memberReducer from "./features/memberSlice/memberSlice";
import addTrialReducer from "./features/hostSlice/addTrialSlice/addTrialSlice";
import hostProfileReducer from "./features/hostSlice/profile/hostProfileSlice";
import manageDogsReducer from "./features/superAdminSlice/manageDogsSlice/manageDogsSlice";
import judgeReducer from "./features/judgeSlice/judgeSlice";
import { globalReducer } from "./globalSlice";

const authPersistConfig = {
	key: "root",
	storage,
};

const rootReducers = combineReducers({
	authReducer,
	memberReducer,
	addTrialReducer,
	hostProfileReducer,
  manageDogsReducer,
  judgeReducer,
});

// Wrap the authReducer with redux-persist
const persistedAuthReducer = persistReducer(authPersistConfig, rootReducers);

export const store = configureStore({
	reducer: {
		auth: persistedAuthReducer,
		dogs: dogReducer,
		global: globalReducer,

		[apiSlice.reducerPath]: apiSlice.reducer,
	},
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat([
			apiSlice.middleware,
		]),
});

export const persistor = persistStore(store);
